import React, { FC, useCallback, useEffect } from "react";
import Head from "next/head";
import { InsurelyResponseItem } from "../store/state/types/insurely";
import { inProduction } from "../../../../config";

const SRC = "https://blocks.insurely.com/";

type InsurelyClientProps = {
  onComplete: (items: InsurelyResponseItem[]) => void;
};

export const Insurely: FC<InsurelyClientProps> = ({ onComplete }) => {
  useEffect(() => {
    const configName = inProduction
      ? "lassie-switcher"
      : "lassie-switcher-test";

    (global.window as any).insurely = {
      config: {
        customerId: "3a84b6cf-e9ec-45fd-a31a-2666b9eb7d6a",
        configName,
        showBackButton: false,
      },
    };
  }, []);

  const insurelyListener = useCallback(
    (event: any) => {
      const { data } = event;

      if (data.name === "RESULTS") {
        const insurelyData = data.value as InsurelyResponseItem[];

        const catAndDogPolicies = insurelyData.filter((item) =>
          ["dogInsurance", "catInsurance"].includes(
            item?.insurance?.insuranceSubType ?? ""
          )
        );

        onComplete(catAndDogPolicies);
      }
    },
    [onComplete]
  );

  useEffect(() => {
    window.addEventListener("message", insurelyListener);

    return function cleanup() {
      window.removeEventListener("message", insurelyListener);
    };
  }, [insurelyListener]);

  return (
    <>
      <Head>
        <script
          async
          type="text/javascript"
          src="https://blocks.insurely.com/assets/bootstrap.js"
        />
      </Head>
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <Head>
          <meta
            name="viewport"
            content="user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, target-densitydpi=device-dpi"
          />
        </Head>
        <iframe
          style={{
            borderWidth: 0,
            width: "100%",
          }}
          src={SRC}
          id="insurelyiframe"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin"
        />
      </div>
    </>
  );
};
